// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var statusText = "statusText-module--status-text--3JUzY";
export var showText = "statusText-module--show-text--23dHp";